import { AfterContentInit, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { ModalVerReferenciasSiniestroResumenComponent } from '../../@modals/modal-ver-referencias-siniestro-resumen/modal-ver-referencias-siniestro-resumen.component';
import { combineLatest, Subscription, take } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { Store } from '@ngrx/store';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatPaginator } from '@angular/material/paginator';
import { NgClass, SlicePipe } from '@angular/common';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';

@Component({
    selector: 'app-detalle-tabla-pagos-recuperaciones-resumen',
    templateUrl: './detalle-tabla-pagos-recuperaciones-resumen.component.html',
    styleUrls: ['./detalle-tabla-pagos-recuperaciones-resumen.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, SlicePipe]
})
export class DetalleTablaPagosRecuperacionesResumenComponent implements AfterContentInit, OnDestroy {

  @ViewChild('pagos') paginatorP: MatPaginator;
  @ViewChild('recuperaciones') paginatorR: MatPaginator;

  @Input() public datosPagos: MatTableDataSource<any> = new MatTableDataSource([]);

  @Input() public datosRecuperaciones: MatTableDataSource<any> = new MatTableDataSource([]);

  public tamanoResultadosPagos: number = 0;
  public selectCoberturasDatosPagos = null;
  public selectedCoberturaRowIndexPagos: number = null;

  public tamanoResultadosRecuperaciones: number = 0;
  public selectCoberturasDatosRecuperaciones = null;
  public selectedCoberturaRowIndexRecuperaciones: number = null;

  public detalleSiniestro;
  public paginatorInfo = { pageStart: 0, pageEnd: 0 };
  public paginatorInfoPagos = { pageStart: 0, pageEnd: 0 };

  public displayColumns = ['Tipo', 'SubTipo', 'Importe', 'Compañia', 'Folio', 'Ref'];
  private listaObservables = new Subscription();

  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>,
  ) {
    this.obtenerReduxState();
  }

  ngAfterContentInit(): void {
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.detalleSiniestro = { ...detalleSiniestro };
    });
    this.listaObservables.add(subsComplemento);
  }

  SelectRow(row, tipo: 'PAGOS' | 'RECUPERACIONES') {
    if (tipo === 'PAGOS') {
      this.selectCoberturasDatosPagos = row.Id;
      this.selectedCoberturaRowIndexPagos = row;
    } else {
      this.selectCoberturasDatosRecuperaciones = row.id;
      this.selectedCoberturaRowIndexRecuperaciones = row
    }
  }

  abrirModalVerReferencias(pagoRecuperacion, tipoCliente: number) {
    const dialog = this.dialog.open(ModalVerReferenciasSiniestroResumenComponent, {
      width: '450px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {
        tipoCliente,
        numeroLiga: pagoRecuperacion?.num_liga,
        pagoRecuperacion
      },
    }).afterClosed().pipe(take(1)).subscribe(data => {

    });
  }

}
